<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<filter-outlet
					v-model="filter"
					@filter="onFilter()"
				></filter-outlet>
			</v-flex>
			<v-flex xs12>
				<app-datatable
					:title="$t('title.outlets_datatable')"
					:endpoint="endpoint"
					:data="data"
					:headers="headers"
					:filter="filter"
					@onEdit="editItem"
					@onDelete="deleteItem"
					@onView="viewItem"
					sortOrder
				>
					<template v-slot:[`item.image`]="{ item }">
						<app-thumbnail-placeholder
							v-model="item.image"
						></app-thumbnail-placeholder>
					</template>
					<template v-slot:[`item.setting`]="{ item }">
						<Link
							as="v-btn"
							outlined
							:href="
								$route('tenant.schedules.index', {
									tenant: $page.props.tenant.id,
									outlet: item.uuid,
								})
							"
						>
							<v-icon left>mdi-clock</v-icon>
							{{ $t("label.schedules") }}
						</Link>
						<Link
							as="v-btn"
							outlined
							:href="
								$route('tenant.reservation_sessions.index', {
									tenant: $page.props.tenant.id,
									outlet: item.uuid,
								})
							"
						>
							<v-icon left>mdi-clock</v-icon>
							{{ $t("label.sessions") }}
						</Link>
						<Link
							as="v-btn"
							outlined
							:href="
								$route('tenant.reservation_shifts.index', {
									tenant: $page.props.tenant.id,
									outlet: item.uuid,
								})
							"
						>
							<v-icon left>mdi-clock</v-icon>
							{{ $t("label.shifts") }}
						</Link>
					</template>
					<template v-slot:[`item.active`]="{ item }">
						<app-active-button
							v-model="item.active"
						></app-active-button>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>

		<app-create-fab-button
			@click="
				$inertia.visit(
					$route('tenant.outlets.create', $page.props.tenant.id)
				)
			"
		></app-create-fab-button>

		<app-tenant-delete-dialog
			ref="deleteDialog"
			:endpoint="'tenant.outlets.destroy'"
			:uuid="item.uuid"
		></app-tenant-delete-dialog>
	</v-container>
</template>

<script>
import pickBy from "lodash/pickBy";
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: { Link },
	props: ["data"],
	data() {
		return {
			filter: {},
			item: {},
		};
	},
	computed: {
		endpoint() {
			return this.$route(
				"tenant.outlets.index",
				this.$page.props.tenant.id
			);
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					sortable: false,
					searchable: false,
					align: "left",
					width: 80,
				},
				{
					text: this.$t("label.cover_image"),
					value: "image",
					align: "start",
					sortable: false,
					width: 80,
				},
				{
					text: this.$t("Name"),
					value: "name",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("label.location"),
					value: "location_name",
					sortable: false,
					searchable: false,
				},
				{
					text: this.$t("Address"),
					value: "address",
					sortable: false,
					searchable: false,
					width: 200,
				},
				{
					text: this.$t("Setting"),
					value: "setting",
					sortable: false,
					searchable: false,
					width: 200,
				},
				{
					text: this.$t("Sort Order"),
					value: "sort_order",
					sortable: false,
					searchable: false,
					width: 100,
					align: "center",
				},
				{
					text: this.$t("Active"),
					value: "active",
					sortable: false,
					searchable: false,
					width: 80,
					align: "right",
				},
			];
		},
	},

	methods: {
		onFilter() {
			var filter = pickBy(this.filter);
			this.$inertia.get(
				this.endpoint,
				{ filter },
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},

		editItem(item) {
			this.$inertia.get(
				this.$route("tenant.outlets.edit", {
					tenant: this.$page.props.tenant.id,
					outlet: item.uuid,
				})
			);
		},

		viewItem(item) {
			this.$inertia.get(
				this.$route("tenant.outlets.show", {
					tenant: this.$page.props.tenant.id,
					outlet: item.uuid,
				})
			);
		},

		deleteItem(item) {
			this.item = Object.assign({}, item);
			this.$refs.deleteDialog.open();
		},
	},
};
</script>